// TravelSimply – Global JS

// Header scroll effect
(function() {
  var header = document.querySelector('.ts-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // Mobile nav toggle
  var toggle = document.querySelector('.ts-mobile-toggle');
  var nav = document.querySelector('.ts-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      nav.classList.toggle('open');
      toggle.textContent = nav.classList.contains('open') ? '✕' : '☰';
    });
  }
})();

// Global toast function
window.tsShowToast = function(msg, link) {
  var toast = document.getElementById('ts-toast');
  if (!toast) return;
  toast.querySelector('.ts-toast-msg').textContent = msg;
  var a = toast.querySelector('a');
  if (a) a.style.display = link ? 'inline' : 'none';
  toast.classList.add('show');
  clearTimeout(window._toastTimer);
  window._toastTimer = setTimeout(function() {
    toast.classList.remove('show');
  }, 4000);
};

// Global scroll reveal
(function() {
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.ts-reveal').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity .5s ease, transform .5s ease';
    observer.observe(el);
  });
})();
